import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { CommercialProposal, FUNDING_ENUM, FundingMethod, FundingService } from '@bytel/checkout';

import { Subject, takeUntil } from 'rxjs';

import { MainCartService } from '../../services/main-cart.service';

@Component({
    selector: 'checkout-credit-accordion',
    templateUrl: './credit-accordion.component.html',
    styleUrl: 'credit-accordion.component.scss',
    standalone: true,
    imports: [NgClass],
})
export class CreditAccordion implements OnInit, OnDestroy {
    public isActive: boolean = true;
    public funding: FundingMethod = null;
    public commercialProposal: CommercialProposal;
    public dynamicData: string = '';
    private cartService: MainCartService = inject(MainCartService);
    private fundingService: FundingService = inject(FundingService);
    private _ngUnsubscribe = new Subject();

    ngOnInit(): void {
        this._setCurrentFunding();
        this._setCommercialProposal();
        this.cartService.paymentMethodObs.pipe(takeUntil(this._ngUnsubscribe)).subscribe(() => {
            this._setCurrentFunding();
            this._setCommercialProposal();
            this.getDynamicData();
        });
        this.getDynamicData();
    }

    public toggleAccordion(): void {
        this.isActive = !this.isActive;
    }

    public ngOnDestroy(): void {
        this._ngUnsubscribe.next(null);
        this._ngUnsubscribe.complete();
    }

    private getFixedRateText(): string {
        if (!this.commercialProposal?.fixedRate) {
            return '';
        }
        return `Taux débiteur fixe ${this.commercialProposal.fixedRate}%.`;
    }

    private getDynamicData(): void {
        const currencyPipe = new CurrencyPipe('fr-FR', 'EUR');
        const monthlyAmount = currencyPipe.transform(this.commercialProposal?.monthlyAmount, 'EUR');
        const totalAmount = currencyPipe.transform(this.commercialProposal?.fundingFinalCost, 'EUR');
        const nbPayments = this.commercialProposal?.nbLoan;
        const taegRate = this.commercialProposal?.tAEG;
        const fixedRateText = this.getFixedRateText();

        this.dynamicData =
            `<b>${nbPayments + (this.funding?.type === FUNDING_ENUM.COFIDIS ? 1 : 0)} mensualités de ${monthlyAmount}/mois</b>. ` +
            `<b>Montant total dû ${totalAmount}</b>${this.funding?.type === FUNDING_ENUM.YOUNITED ? ' (hors assurance facultative)' : ''} ` +
            `<b>TAEG fixe&nbsp;: ${taegRate}%</b>. ` +
            fixedRateText;
    }

    private _setCurrentFunding(): void {
        const fundingMethod = this.cartService.cartModel.fundingMethod;
        this.funding = fundingMethod?.commercialProposal[0]?.nbLoan > 0 ? fundingMethod : null;
    }

    private _setCommercialProposal(): void {
        this.commercialProposal =
            this.funding?.type === 'YOUNITED'
                ? this.fundingService.getYounitedSelectedProposal(this.funding)
                : this.fundingService.getCofidisSelectedProposal(this.funding);
    }
}
